'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdEuroSymbol = function MdEuroSymbol(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 30.9c2.7 0 5.2-1.1 7-2.7l3 3c-2.7 2.4-6.2 3.8-10 3.8-6.6 0-12.1-4.2-14.1-10h-5.9v-3.4h5.1c-0.1-0.5-0.1-1.1-0.1-1.6s0-1.1 0.1-1.6h-5.1v-3.4h5.9c2-5.8 7.5-10 14.1-10 3.8 0 7.3 1.4 10 3.8l-3 3c-1.8-1.6-4.3-2.7-7-2.7-4.1 0-7.8 2.5-9.6 5.9h9.6v3.4h-10.7c-0.1 0.5-0.2 1.1-0.2 1.6s0.1 1.1 0.2 1.6h10.7v3.4h-9.6c1.8 3.4 5.4 5.9 9.6 5.9z' })
        )
    );
};

exports.default = MdEuroSymbol;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/euro-symbol.js
// module id = 2275
// module chunks = 0